import { CHAIN_IDS } from 'shared/config/wagmi';
// eslint-disable-next-line import/no-extraneous-dependencies
import invariant from 'tiny-invariant';

export enum SCANNER_ENTITIES {
  Tx = 'tx',
  Token = 'token',
  Address = 'address',
}

export type ScannerEntities = `${SCANNER_ENTITIES}`;

const SCANNER_NAMES_BY_NETWORK: Record<CHAIN_IDS, string> = {
  [CHAIN_IDS.BSC]: 'bscscan',
  [CHAIN_IDS.BSC_TESTNET]: 'bscscan',
  [CHAIN_IDS.CRAT_TESTNET]: 'CratD2C Scan',
  [CHAIN_IDS.CRAT]: 'CratD2C Scan',
  [CHAIN_IDS.HOLESKY]: 'CratD2C Scan',
};

export const SCANNER_PREFIX_BY_NETWORK: Record<CHAIN_IDS, string> = {
  [CHAIN_IDS.BSC]: 'bscscan.com',
  [CHAIN_IDS.BSC_TESTNET]: 'testnet.bscscan.com',
  [CHAIN_IDS.CRAT_TESTNET]: 'explorer-testnet.cratd2csmartchain.io',
  [CHAIN_IDS.CRAT]: 'explorer.cratd2csmartchain.io',
  [CHAIN_IDS.HOLESKY]: 'explorer-testnet.cratd2csmartchain.io',
};

export const getScannerPrefix = (chainId: CHAIN_IDS): string => {
  const prefix = SCANNER_PREFIX_BY_NETWORK[chainId];
  invariant(prefix != null, 'Chain is not supported');
  return prefix;
};

export const getScannerName = (chain: CHAIN_IDS) => {
  const name = SCANNER_NAMES_BY_NETWORK[chain];
  invariant(name != null, 'SCANNER NAME is not supported');
  return name;
};

export const getScannerLink = (chainId: CHAIN_IDS, hash: string, entity: ScannerEntities): string => {
  const prefix = getScannerPrefix(chainId);
  return `https://${prefix}/${entity}/${hash}`;
};

export const getScannerTxLink = (chainId: CHAIN_IDS, hash: string): string => {
  return getScannerLink(chainId, hash, SCANNER_ENTITIES.Tx);
};

export const getScannerTokenLink = (chainId: CHAIN_IDS, address: string): string => {
  return getScannerLink(chainId, address, SCANNER_ENTITIES.Address);
};

export const getScannerAddressLink = (chainId: CHAIN_IDS, hash: string): string => {
  return getScannerLink(chainId, hash, SCANNER_ENTITIES.Address);
};
